<div class="msisdn-label">
  <div class="iti-flag" [ngClass]="getFlagClass(msisdn)"></div>
  <div class="text-ellipsis" title="{{msisdn.label}}">{{msisdn.label}}</div>
</div>
<div
  *ngIf="!small"
  class="msisdn-number text-ellipsis"
  title="{{msisdn.msisdn ? msisdn.msisdn : 'PENDING_DOTS' | translate }}">
  {{msisdn.msisdn ? (msisdn.msisdn | phoneNumber) : 'PENDING_DOTS' | translate }}
</div>
